export enum EventAction {
  ActivateItsmeDeedsSharing = 'Activate Itsme Deeds Sharing',
  DeactivateItsmeDeedsSharing = 'Deactivate Itsme Deeds Sharing',
  ApplyFilter = 'Apply Filter',
  ApplyHistoryLogFilter = 'Apply History Log Filter',
  SelectedCategory = 'Selected Category',
  TogglePdfConversion = 'Toggle PDF Conversion',
  UploadedDocument = 'Uploaded Document',
  UploadFromCameraRoll = 'Upload From Camera Roll',
  TakeAPicture = 'Take A Picture',
  PushDocuments = 'Push Documents',
  ScanDocuments = 'Scan Documents',
  UploadDocuments = 'Upload Documents',
  SharedDocumentCitizen = 'Shared Document Citizen',
  SharedNabanDocumentCitizen = 'Shared Naban Document Citizen',
  SharedDocumentStudy = 'Shared Document Study',
  SharedNabanDocumentStudy = 'Shared Naban Document Study',
  UnsharedDocument = 'Unshared Document',
  DownloadedDocument = 'Downloaded Document',
  ExportedDocument = 'Exported Document',
  RemovedDocument = 'Removed Document',
  ManagedDocumentLabels = 'Managed Document Labels',
  ManagedDocumentCategories = 'Managed Document Categories',
  OpenendPrivacyPolicy = 'Opened Privacy Policy',
  OpenedFAQ = 'Opened FAQ',
  AddedContact = 'Added Contact',
  AddedNotary = 'Added Notary',
  AddedHeir = 'Added Heir',
  DeletedContact = 'Deleted Contact',
  CopyDeedDocument = 'Copy Deed Document',
  ViewDeedDocument = 'View Deed Document',
  DownloadDeedDocument = 'Download Deed Document',
  ToggleVaultTransferPreferences = 'Toggle Vault Transfer Preferences',
  AddVaultTransfer = 'Add Vault Transfer',
  EditVaultTransfer = 'Edit Vault Transfer',
  DeleteVaultTransfer = 'Delete Vault Transfer',
  DuplicateVaultTransfer = 'Duplicate Vault Transfer',
  SaveVaultTransferAll = 'Save Vault Transfer All',
  SaveVaultTransferSpecific = 'Save Vault Transfer Specific',
  ReportedAProblem = 'Reported A Problem',
  DeletedDocumentsPermanently = 'Deleted Documents Permanently',
  RecoveredDocument = 'Recovered Document',
  DeactivatedAccount = 'Deactivated Account',
  RegisteredPersonalData = 'Registered Personal Data',
  RegisteredEmailAddress = 'Registered Email Address',
  RegisteredTermsAndConditions = 'Registered Terms And Conditions',
  RegisteredNaban = 'Registered Naban',
  UpdatedEmailAddress = 'Updated Email Address',
  AddedEmailAddress = 'Added Email Address',
  SelectedPreferredNotary = 'Selected Preferred Notary',
  AcceptedNotifications = 'Accepted Notifications',
  CertifyInstallPlugin = 'Certify Install Plugin',
  CertifyChooseContact = 'Certify Choose Contact',
  CertifyAbort = 'Certify Abort',
  CertifyOriginDocument = 'Certify Origin Document',
  CertifyIdenticalDocument = 'Certify Identical Document',
  CertifySignatureDocument = 'Certify Signature Document',
  CertifyOtherDocument = 'Certify Other Document',
  CertificationScanDocuments = 'Certification Scan Documents',
  CertificationTakePicture = 'Certification Take Picture',
  CertificationCameraRoll = 'Certification Camera Roll',
  CertificationUploadDocuments = 'Certification Upload Documents',
  CertificationUploadFromVault = 'Certification Upload From Vault',
  CertificationPreferredNotary = 'Certification Preferred Notary',
  CertificationOtherNotary = 'Certification Other Notary',
  SSNConnectionAdded = 'Connection SSN Added',
  SSNConnectionRemoved = 'Connection SSN Removed',
  StartedOnboarding = 'Started Onboarding',
  AccountExisting = 'Account Existing',
  CompletedOnboarding = 'Completed Onboarding',
  LoginButtonPressed = 'LoginButtonPressed',
  InheritedVaultNavigation = 'Navigate to Inherited Vault',
  ClaimVault = 'Claim Vault',
  TransferVault = 'Transfer Vault',
  CopiedInheritedDocuments = 'Copied Inherited Documents',
  DownloadedInheritedDocuments = 'Downloaded Inherited Documents',
  OpenedInheritedDocument = 'Opened Inherited Document',
  InheritanceCardPress = 'Inheritance Card Press',
  PostedSocialMedia = 'Posted Social Media',
  SharedIzimiFromNudge = 'Shared Izimi From Nudge',
  ItsmeSharingAutomaticLogin = 'ItsmeSharingAutomaticLogin',
  LogoutButtonClicked = 'Logout button clicked',
  LanguageSelectionUpdated = 'Language selection updated',
  // Naban UI
  PersonalActsAuthenticationMethodSelected = 'Personal acts authentication method selected',
  CompanyActsAuthenticationMethodSelected = 'Company acts authentication method selected',
  SisterCompanyActsAuthenticationMethodSelected = 'Sister company acts authentication method selected',
  HeirAuthenticationMethodSelected = 'Heir authentication method selected',
  OverviewRegistersTabSelected = 'Overview registers tab selected',
  OverviewDeedsTabSelected = 'Overview deeds tab selected',
  DeedDownloaded = 'Deed downloaded',
  DeedAttachedFileDownloaded = 'Deed attached file downloaded',
  IzimiAccountCreationButtonClicked = 'Izimi account creation button clicked',
  NotaryWebsiteButtonClicked = 'Notary website button clicked',
  GlossaryModalOpened = 'Glossary modal opened',
}
